export enum TypeEvenement {
	TELETRAVAIL = 'TELETRAVAIL',
	CONGE = 'CONGE',
	TRAVAILLE_AILLEURS = 'TRAVAILLE_AILLEURS',
	// Utilisé seulement côté front pour la déclaration d'un évènement calendrier (évènement ou réservation)
	BUREAU = 'BUREAU'
}
